<template>
  <div id="app">
    <router-view/>
    <right-sidebar :is-expanded='sidebarIsExpanded'
                    v-if="this.$store.getters.isAuthenticated"
                    @toogleExpandState='toggleSidebarExpandState'>
      <feed-back-form :form-is-opened="sidebarIsExpanded" @submitted='toggleSidebarExpandState'/>
    </right-sidebar>
  </div>
</template>
<script>
  import RightSidebar from './components/RightSidebar'
  import FeedBackForm from './components/FeedBackForm'

export default {
  components: {
    RightSidebar,
    FeedBackForm
  },
  methods: {
    toggleSidebarExpandState() {
      this.$store.commit("toggleSidebarState")
    }
  },
  computed: {
    sidebarIsExpanded() {
      return this.$store.state.rightSidebarIsExpanded
    }
  },
  async created() {
    await this.$store.dispatch('setupAxiosAuthHeader')
  }
}
</script>
<style lang="sass">
  @import 'assets/sass/typography'
</style>
